const PHONE_RE = /(\+33[\s.\-]?|0033[\s.\-]?|0)[1-9](?:[\s.\-]?\d{2}){4}/g;

export default function PhoneText({ text = "", linkClassName = "font-semibold text-primary underline underline-offset-2" }) {
  const parts = [];
  let last = 0;
  let i = 0;
  for (const m of text.matchAll(PHONE_RE)) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const raw = m[0];
    const tel = raw.replace(/[\s.\-()]/g, "").replace(/^0033/, "+33");
    parts.push(
      <a key={i++} href={`tel:${tel}`} className={linkClassName}>
        {raw}
      </a>
    );
    last = m.index + raw.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts}</>;
}
